import React from 'react';
import { Box, Typography } from '@mui/material';

interface SectionHeaderProps {
  label: string;
}

export const SectionHeader = ({
  label,
}: SectionHeaderProps) => {
  return (
    <Typography sx={{
      color: '#4F4F4F',
      fontSize: '16px',
      fontWeight: '500',
      textTransform: 'uppercase',
      marginBottom: '14px',
    }}>
      {label}
    </Typography>
  )
}
